
<template>

  <div class="ui center aligned inverted primary segment">
    <div class="ui centered grid">

      <!-- Participations counter -->
      <div class="row">
        <div class="center aligned column">

          <h2 class="ui almarai yellow header">
            {{ participations }}
            <div class="sub header">مشاركات</div>
          </h2>

        </div>
      </div>

      <!-- Change buttons -->
      <div class="four column doubling row">

        <div class="column" style="padding: 0 0 0 5px;">
          <button class="ui fluid yellow icon button" @click="increment(1)">
            +1
          </button>
        </div>

        <div class="column" style="padding: 0 0 0 5px;">
          <button class="ui fluid yellow icon button" @click="increment(10)">
            +10
          </button>
        </div>

        <div class="column" style="padding: 0 0 0 5px;">
          <button class="ui fluid yellow icon button" @click="increment(100)">
            +100
          </button>
        </div>

        <div class="column" style="padding: 0 0 0 3px;">
          <button class="ui fluid yellow icon button" @click="reset()">
            <i class="undo icon" />
          </button>
        </div>

      </div>

      <!-- Participate button -->
      <div class="row">
        <button class="ui fluid yellow button" @click="participate()">
          <span class="ui almarai large text">شارك</span>
        </button>
      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {

  name: 'Participation',
  props: {

    work: Object

  },
  data: () => ({

    participations: 0,

  }),
  watch: {

    work(newWork) {

      if (newWork.target && newWork.completed + this.participations > newWork.target) {

        this.participations = newWork.target - newWork.completed;

      }

    }

  },
  methods: {

    increment(stepSize) {

      if (this.work.target) {

        if (this.work.completed + this.participations + stepSize <= this.work.target)
          this.participations += stepSize;

      } else {

        if (this.participations < stepSize * 10)
          this.participations += stepSize;

      }

    },

    reset() {

      this.participations = 0;

    },

    async participate() {

      if (this.participations === 0) {

        alert('يرجى اختيار عدد المشاركات');
        return;

      }

      if (confirm(`أشارك بهذا العمل ${this.participations} مشاركات وأهدي ثوابه إلى ${this.work.ehdaa} وجميع المشاركين بالعمل وموتاهم`)) {

        try {

          await axios.put(`${process.env.VUE_APP_BASE_URL}/works`, {

            workID: this.work.id,
            increment: this.participations

          });

          this.reset();

          this.$gtag.event('Participate', {

            event_category: 'Works',
            event_label: `${this.work.title} - ${this.work.ehdaa}`,
            value: this.participations

          });

        } catch (err) {

          alert(err);

        }

      }

    }

  }

}
</script>

<style scoped>
button {
  touch-action: manipulation;
}
</style>
